import { Component, Input } from '@angular/core';
import { PatDmrRelatedData } from '../../models/ai-model';

import { MatIcon } from '@angular/material/icon';
import { AiService } from '../../services/ai.service';
import { FormsModule } from '@angular/forms';
import { marked } from 'marked';
import TurndownService from 'turndown';
import { ClineaseButtonComponent } from '../../shared/clinease-button/clinease-button.component';
import { SharedModule } from '../../shared/shared.module';
import { ErrorPanelService } from '../../services/error-panel.service';

@Component({
  selector: 'app-ai-patdmr',
  standalone: true,
  imports: [FormsModule, SharedModule],
  templateUrl: './ai-patdmr.component.html',
  styleUrl: './ai-patdmr.component.scss',
})
export class AiPatDmrComponent {
  // TODO: removed last_generation_date and last_generation_time, to decide if we need them somewhere else
  @Input() patDmrRelatedData: PatDmrRelatedData = {
    html: '',
    last_generation_date: '',
    last_generation_time: '',
  };
  @Input() patientId: string = '';
  @Input() isEditing: boolean = false;
  @Input() isLoading: boolean = true;

  markdownContent: string = '';
  private turndownService = new TurndownService();

  constructor(
    private aiService: AiService,
    private errorPanelService: ErrorPanelService
  ) {}

  ngOnChanges() {
    if (this.isEditing) {
      this.markdownContent = this.turndownService.turndown(
        this.patDmrRelatedData.html
      );
    } else if (this.markdownContent) {
      const htmlContent = marked.parse(this.markdownContent) as string;
      this.patDmrRelatedData.html = htmlContent;
      this.updateDmr(htmlContent);
    }
  }

  onMarkdownChange(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    this.markdownContent = textarea.value;
  }

  private updateDmr(htmlContent: string) {
    if (!this.patientId) return;

    this.aiService.updatePatDmr(this.patientId, htmlContent).subscribe({
      next: () => console.log('DMR updated successfully'),
      error: (error) => {
        console.error('Error updating DMR:', error);
        this.errorPanelService.showErrorSnackBar(
          "Errore nell'aggiornare il DMR"
        );
      },
    });
  }
}
